import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.bottom');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-bottom',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.bottom/view.scss */
:host {
  display: block;
  width: 100%;
}

.bottom-nav {
  min-height: calc(var(--th-nav-height) + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 40;
  width: min(var(--app-shell-width, 480px), 100vw);
  transform: translateX(-50%);
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.08);
  transition: transform 0.18s ease;
}

:host-context(.chat-keyboard-open) .bottom-nav {
  transform: translate(-50%, 100%);
  pointer-events: none;
}

.nav-tab {
  background: none;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease, scale 0.16s ease, translate 0.16s ease;
  -webkit-tap-highlight-color: transparent;
  min-height: var(--th-nav-height);
  overflow: hidden;
}
.nav-tab:active {
  scale: 0.94;
  translate: 0 1px;
}

.icon-wrapper,
.nav-icon,
.nav-label {
  transition: background-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease, scale 0.16s ease;
}

.icon-wrapper {
  width: 44px;
  height: 44px;
  margin-bottom: 4px;
  flex-shrink: 0;
}

.nav-icon {
  width: 26px;
  height: 26px;
}

.nav-label {
  font-size: var(--app-font-sm, 16px);
  font-weight: 500;
  line-height: 1.1;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.safe-area-bottom {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}`],
})
export class ComponentNavBottomComponent implements OnInit, OnDestroy {
    public tabs: any[] = [
        { id: 'home', label: '홈', icon: 'home', route: '/home' },
        { id: 'analysis', label: '건강분석', icon: 'chart', route: '/analysis' },
        { id: 'chatbot', label: 'AI상담', icon: 'message-circle', route: '/chatbot' },
        { id: 'records', label: '건강기록', icon: 'clipboard', route: '/records' },
        { id: 'mypage', label: '마이', icon: 'user', route: '/mypage' }
    ];

    public activeTab: string = 'home';
    private routeSub: Subscription | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.updateActiveTab();
        this.routeSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateActiveTab();
                void this.service.render();
            }
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routeSub) {
            this.routeSub.unsubscribe();
        }
    }

    public updateActiveTab() {
        const path = window.location.pathname;
        this.activeTab = 'home';
        for (const tab of this.tabs) {
            if (path.startsWith(tab.route)) {
                this.activeTab = tab.id;
                break;
            }
        }
    }

    public async navigate(tab: any) {
        this.activeTab = tab.id;
        this.service.href(tab.route);
        await this.service.render();
    }
}

export default ComponentNavBottomComponent;